
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as TrendDownIconComponent } from "./trend-down-icon.svg";

export const TrendDownIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <TrendDownIconComponent {...props} />;
};
